import { Award, CheckCircle, Shield, Zap } from "lucide-react";

const trustSignals = [
  {
    icon: Award,
    title: "15+ Years Experience",
    description: "Deep expertise in CAD development since 2005. Trusted by many US and Europe MNCs and leading engineering firms."
  },
  {
    icon: Shield,
    title: "Enterprise-Grade Solutions",
    description: "Deployed across 200+ engineers in mission-critical environments at many US and Europe MNCs. Mission-critical reliability and 24/7 support.",
  },
  {
    icon: CheckCircle,
    title: "100% Custom Development",
    description: "Bespoke solutions tailored to your exact workflow. No templates—every project is engineered from scratch."
  },
  {
    icon: Zap,
    title: "24-Month Warranty",
    description: "Complete post-deployment support. Bug fixes, maintenance, and optimization included for 24 months."
  }
];

const stats = [
  { number: "50+", label: "Enterprise Clients" },
  { number: "200+", label: "Engineers Empowered" },
  { number: "150+", label: "Automation Tools" },
  { number: "95%", label: "Client Satisfaction" }
];

const TrustSignalsSection = () => {
  return (
    <section 
      id="trust-signals" 
      data-testid="trust-signals-section"
      className="py-20 lg:py-28 bg-gradient-to-r from-[#06B6D4] to-[#0E7490]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            data-testid="trust-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Why Engineers Choose Us
          </h2>
          <p className="mt-4 text-lg text-cyan-100 max-w-2xl mx-auto">
            Proven reliability, expertise, and commitment to your success
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              data-testid={`stat-${idx}`}
              className="text-center"
            >
              <p className="text-4xl sm:text-5xl font-bold text-white mb-2">
                {stat.number}
              </p>
              <p className="text-cyan-100 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Trust Signals Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          {trustSignals.map((signal, idx) => (
            <div
              key={idx}
              data-testid={`trust-signal-${idx}`}
              className="flex gap-6 bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 hover:bg-white/20 transition-all"
            >
              <div className="flex-shrink-0">
                <signal.icon className="w-8 h-8 text-cyan-200" />
              </div>
              <div>
                <h3 
                  className="text-xl font-bold text-white mb-2"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {signal.title}
                </h3>
                <p className="text-cyan-100 leading-relaxed">
                  {signal.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignalsSection;
